export default __webpack_public_path__ + "static/media/My-Benefits.7c49156d.svg";